import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const PaymentLogo = styled.img`
  width: ${({ $isBig }) => ($isBig ? "400px" : "250px")};
  padding: ${({ $padding }) => $padding};

  @media (max-width: ${({ theme }) => theme.breakpoints.phone}) {
    width: ${({ $isBig }) => ($isBig ? "300px" : "250px")};
  }
`;

const DinteroPayments = ({ padding, variant, isBig }) => {
  const accountId = process.env.GATSBY_DINTERO_ACCOUNT_ID;

  let src = "";

  switch (variant) {
    case "color":
      src = `https://checkout.dintero.com/v1/branding/accounts/${accountId}/profiles/default/variant/colors/color/cfcfcf/width/500/dintero_top_frame.svg`;
      break;
    case "white":
      src = `https://checkout.dintero.com/v1/branding/accounts/${accountId}/profiles/default/variant/mono/color/ffffff/width/500/dintero_top_frame.svg`;
      break;
    case "black":
      src = `https://checkout.dintero.com/v1/branding/accounts/${accountId}/profiles/default/variant/mono/color/000000/width/500/dintero_top_frame.svg`;
      break;
    default:
      src = `https://checkout.dintero.com/v1/branding/accounts/${accountId}/profiles/default/variant/colors/color/cfcfcf/width/500/dintero_top_frame.svg`;
  }

  return (
    <PaymentLogo
      alt="betalingsmåter for dintero"
      loading="lazy"
      $padding={padding}
      $isBig={isBig}
      src={src}
    />
  );
};

DinteroPayments.propTypes = {
  padding: PropTypes.string,
  variant: PropTypes.string,
  isBig: PropTypes.bool,
};

DinteroPayments.defaultProps = {
  padding: 0,
  variant: "color",
  isBig: false,
};

export default DinteroPayments;
